<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row type="flex" justify="right">
            <el-button size="mini" @click="back" type="primary">{{$t('common.close')}}</el-button>
          </el-row>
        </el-form>
        <el-table :data="tableData" border highlight-current-row class="table" style="margin-top:5px">
          <el-table-column show-overflow-tooltip fixed sortable prop="sourcingNo" align="center" :label="$t('base.linePrice.sourcingNo')" min-width="130px">
            <template slot-scope="scope">
              <el-link v-if="emplFlag == 'MCD'" type="primary" @click="querySourcingLine(scope.row.sourcingNo,scope.row.type)"> {{scope.row.sourcingNo}} </el-link>
              <span v-if="emplFlag != 'MCD'">{{scope.row.sourcingNo}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" :label="$t('base.linePrice.supplier')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="pickupPoint" align="center" :label="$t('base.linePrice.pickupPoint')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="dcName" align="center" :label="$t('base.linePrice.dc')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="temperatureI18n" align="center" :label="$t('base.linePrice.temperature')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="unitI18n" align="center" :label="$t('base.linePrice.unit')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="transportaionMethodI18n" align="center" :label="$t('base.linePrice.transportaionMethod')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="effectiveBeginDate" min-width='100' align="center" :label="$t('base.linePrice.effectiveBeginDate')">
            <template slot-scope="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="price" align="center" min-width='100' :label="$t('base.linePrice.price')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="currencyCode" align="center" :label="$t('base.linePrice.currencyCode')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="leadTime" align="center" label="LeadTime"></el-table-column>
        </el-table>
      </div>
    </div>

    <!--========= 报价确认明细 =========-->
    <!-- <el-dialog :visible.sync="SourcingLineDialog" append-to-body width="80%"  >
            <sourcingDetail  :sourcingNo=sourcingNo ref="sourcingRef" ></sourcingDetail>
        </el-dialog> -->
    <!--========= 报价确认明细 =========-->
  </div>
</template>
<script>
import { search } from "../../../api/base-data/linePriceData";
import sourcingDetail from '../quotation-apply/sourcing-detail';
import router from '../../../router';
export default {
  name: 'linePriceDetail',
  components: {
    sourcingDetail
  },
  data() {
    return {
      emplFlag: null,
      sourcingNo: '',
      tableData: [],
      SourcingLineDialog: false,
      queryCondition: {
        pageSize: 0,
        tmPickupId: '',
        temperature: '',
        tmDcId: '',
        transportaionMethod: '',
      }
    }
  },
  props: {
    tmPickupId: '',
    temperature: '',
    tmDcId: '',
    transportaionMethod: '',
  },
  created() {
    this.queryCondition.tmPickupId = this.$route.params.tmPickupId;
    this.queryCondition.temperature = this.$route.params.temperature;
    this.queryCondition.tmDcId = this.$route.params.tmDcId;
    this.queryCondition.transportaionMethod = this.$route.params.transportaionMethod;
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    this.queryData();
    // this.getInputChoiceValues();
  },
  methods: {

    queryData() {
      search(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
      })
    },

    //查询报价确认明细
    querySourcingLine(sourcingNo, type) {
      //this.sourcingNo = sourcingNo;
      //this.SourcingLineDialog = true;
      if ('LINE' == type) {
        this.$router.push({
          path: "/sourcing-detail",
          query: { sourcingNo: sourcingNo }
        });
      } else {
        this.$router.push({
          path: `/sourcingByProduct-detail`,
          query: { sourcingNo: sourcingNo }
        });
      }

    },
    back() {
      this.$router.replace({
        path: '/linePriceData'
      });
    },
  }



}


</script>
